import { P } from "../../../../../AbstractElements";

const UserMailBody = () => {
  return (
    <div className="user-body">
      <P>Dear Customer,</P>
      <P>We regret to notify you that an unauthorized attempt was made to accessyour account. Our system discovered suspicious activity, and we actedright away to safeguard your personal data.</P>
      <P>Please change your login information by clicking the following link inorder to safeguard your account:</P>
      <P>Please be aware that your account may be temporarily suspended if noaction is taken within 24 hours. We urge you to take immediate action toprevent any inconvenience.</P>
      <P>We sincerely apologize for any inconvenience this may cause and thankyou for your immediate attention to this matter.</P>
      <div className="mail-subcontent">
        <P>Yours faithfully,</P>
        <P>Account Security Team</P>
      </div>
    </div>
  );
};

export default UserMailBody;
